class GenericSlider {
  constructor(container) {
    this.container = container;
    this.autoplayEnabled = false;
    this.autoplayCarouselSpeed = 5 * 1000;
    this.splideInstance = null;
    this.init();
  }

  init() {
    this.handleSplideSlider(this.container);
  }

  handleSplideSlider(container) {
    const genericSliderSlideshow = container.querySelector('[generic-slider-slideshow]');

    if (genericSliderSlideshow) {
      this.splideInstance = new Splide(genericSliderSlideshow, {
        type: 'slide',
        perPage: 3,
        perMove: 3,
        mobileFirst: true,
        autoplay: this.autoplayEnabled,
        interval: this.autoplayCarouselSpeed,
        arrows: true,
        pagination: true,
        speed: 1000,
        trimSpace: 'move',
        breakpoints: {
          767: {
            perPage: 1,
            perMove: 1,
            pagination: false,
            centerMode: true,
            variableWidth: true,
          },
          1439: {
            perPage: 2,
            perMove: 2
          }
        },
      }).mount();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const genericSliderSection = document.querySelector('[component-generic-slider]');
  if (genericSliderSection) {
    const genericSlider = new GenericSlider(genericSliderSection);

  }
});
